import { inject, Injectable } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';

import { I18nService } from './i18n.service';
import { LocaleService } from './locale.service';

@Injectable({ providedIn: 'root' })
export class I18nTitleService {
  private readonly router = inject(Router);
  private readonly route = inject(ActivatedRoute);
  private readonly title = inject(Title);
  private readonly i18n = inject(I18nService);
  private readonly locale = inject(LocaleService);

  init(): void {
    this.router.events.pipe(filter((e) => e instanceof NavigationEnd)).subscribe(() => {
      this.locale.locale();
      this.applyTitle();
    });
    this.applyTitle();
  }

  private applyTitle(): void {
    let current = this.route.snapshot;
    while (current.firstChild) {
      current = current.firstChild;
    }

    const titleKey = current.data['titleKey'] as string | undefined;
    const breadcrumbKey = current.data['breadcrumbKey'] as string | undefined;
    const key = titleKey ?? breadcrumbKey;
    if (key) {
      this.title.setTitle(this.i18n.t(key));
      return;
    }

    const staticTitle = current.title ?? current.data['breadcrumb'];
    if (typeof staticTitle === 'string' && staticTitle.trim()) {
      this.title.setTitle(staticTitle);
    }
  }
}
